/**
 * Host-agnostic classification of pill-click failures.
 *
 * `outlookPills.ts` holds the Outlook-specific classifiers. Anything that can
 * fail identically in Word, Outlook or PowerPoint belongs here instead — the
 * case that prompted this file was a WORD pill (`word.strip_styles`) whose
 * failure was being classified by a module named for Outlook.
 */

/**
 * Whether the click failed because no handler exists for it.
 *
 * Happens when a pill outlives the code that could service it: the add-in was
 * rebuilt (or the user switched build) while an older turn stayed on screen, so
 * the button is still there but its handler is gone. The raw error —
 * "no handler registered for word.strip_styles (host=word)" — names an internal
 * registry key and a host flag, which tells a user nothing they can act on.
 */
export function isUnknownHandlerError(error: unknown): boolean {
  if (typeof error !== "string") return false;
  return error.toLowerCase().includes("no handler registered");
}
